module.exports = __webpack_public_path__ + "assets/img/title-558ab442.png";